module.exports = __webpack_public_path__ + "static/media/(000067).24bdf9b6.jpg";